import React from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

import AnimationHelpers from "../../../../../../utils/AnimationHelpers";
import { blue } from "../../../../../../utils/colors";
import Backdrop from "../../../../Backdrop";
import { BlurOther } from "../../../../Blur";
import ChevronIcon from "../../../../icons/ChevronIcon";
import { Link } from "../../../../LinkComponent";
import HoyerCard from "../../../HoyerCard";
import Language from "../../../Language";
import ShoppingCart from "../../../ShoppingCart";
import TechnicList from "../../../TechnicList";
import MobileDropdown from "../MobileDropdown";

const iconContainerState = (props) => ({
    width: props.small ? "20px" : "25px",
});

const IconContainer = styled.div`
    ${iconContainerState};

    display: flex;
`;

const MobileNav = styled.div`
    display: flex;
    flex-direction: column;
    ${({ theme }) => css`
        ${theme.paddings.containerOuter.all}
    `}

    background-color: ${({ theme }) => theme.colors.white.toString()};
    color: ${({ theme }) => theme.colors.blue.toString()};
    ${({ theme }) => theme.breakpoints.from.medium.css`
      overflow-x: hidden;
    `}
`;

const Modal = styled.div`
    position: fixed;
    top: 60px;
    left: 0;
    z-index: 50;
    display: none;
    width: 100%;
    height: 93svh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    &.fade-in {
        ${({ theme }) => theme.breakpoints.upTo.large.css`
            display: block;
            animation: ease 0.5s ${AnimationHelpers.fadeIn} forwards;
        `}
    }

    &.fade-out {
        ${({ theme }) => theme.breakpoints.upTo.large.css`
            display: block;
            animation: ease 0.5s ${AnimationHelpers.fadeOut} forwards;
        `}
    }
`;

const TopRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
`;

export const TopRowItemWrapper = styled.div`
    flex-grow: 1;
`;

const LinkItem = css`
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.blue.toString()};
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: initial;
`;

const NavBackdrop = styled(Backdrop)`
    top: 60px;
    z-index: 50;
`;

const MobileModal = ({ modalState = null, handleClick, sections }) => {
    return (
        <>
            {modalState && <BlurOther except={["Nav"]} />}

            <NavBackdrop onClick={handleClick} open={modalState} />

            <Modal
                className={classNames(
                    modalState != null && {
                        "fade-in": modalState,
                        "fade-out": !modalState,
                    }
                )}
            >
                <Wrapper>
                    <MobileNav>
                        <TopRow>
                            <HoyerCard handleMobileNav={handleClick} />

                            <TechnicList />

                            <ShoppingCart />

                            <Language
                                section={sections[5]}
                                handleMobileNav={handleClick}
                            />
                        </TopRow>
                        {sections.map((section, i) => {
                            if (
                                section.name.toLowerCase() === "translation" ||
                                section.name.toLowerCase() ===
                                    "tankstellenfinder"
                            )
                                return null;
                            return section.subsections &&
                                section.subsections.length > 0 ? (
                                <MobileDropdown key={i} section={section} />
                            ) : (
                                <Link key={i} to={section.href} css={LinkItem}>
                                    <div>{section.name}</div>
                                    <div>
                                        <IconContainer small>
                                            <ChevronIcon color={blue} />
                                        </IconContainer>
                                    </div>
                                </Link>
                            );
                        })}
                    </MobileNav>
                </Wrapper>
            </Modal>
        </>
    );
};

export default MobileModal;
